import React from 'react';

const SortIcon = ({ active, direction }) => {
    if (!active) {
        return (
            <svg className="w-3.5 h-3.5 text-gray-400 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l4-4 4 4M8 15l4 4 4-4" />
            </svg>
        );
    }
    if (direction === 'asc') {
        return (
            <svg className="w-3.5 h-3.5 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
            </svg>
        );
    }
    return (
        <svg className="w-3.5 h-3.5 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
    );
};

/**
 * Clickable column header for client-side (or server-driven) table sorting.
 */
export default function SortableTableHeader({
    label,
    columnKey,
    sortKey,
    sortDir,
    onSort,
    className = 'table-header-cell',
    align = 'left',
}) {
    const active = sortKey === columnKey;
    const alignClass = align === 'center' ? 'justify-center' : align === 'right' ? 'justify-end' : 'justify-start';

    return (
        <th className={className} aria-sort={active ? (sortDir === 'asc' ? 'ascending' : 'descending') : 'none'}>
            <button
                type="button"
                onClick={() => onSort(columnKey)}
                className={`inline-flex max-w-full items-center gap-1 ${alignClass} font-semibold text-inherit hover:text-primary-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 rounded`}
            >
                <span>{label}</span>
                <SortIcon active={active} direction={sortDir} />
            </button>
        </th>
    );
}
